import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import CourseFormContainer from '@/containers/admin/CourseFormContainer';

interface CourseFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  courseId?: string | null;
}

const CourseFormModal: React.FC<CourseFormModalProps> = ({ isOpen, onClose, courseId }) => {
  const { t } = useTranslation('admin');
  return (
    <Modal isOpen={isOpen} size="2xl" onClose={onClose} placement="center" backdrop="blur" scrollBehavior="inside">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          {courseId ? t('courses.modal.edit.title') : t('courses.modal.create.title')}
        </ModalHeader>
        <ModalBody>
          <CourseFormContainer courseId={courseId} onSuccess={onClose} onCancel={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CourseFormModal;
